// extracted by mini-css-extract-plugin
module.exports = {"container":"role_container__3QaZ0","table":"role_table__1ny3s"};